export const MAX_RESULTS = 10_000;
